import { 
    yellow,
    red,
    blue,
    grey,
    axisName,
    pageBg
} from './color'
import util from '@/utils/util.js'

export var get1 = function(){
  return {
    trigger: 'axis',
    $axisIndex: 0,
    position: [0, 222],
    alwaysShowContent: true,
    confine: false,
    formatter: function(d){
      var str = ''
      d.allSeries.map(function(item, i) {
        let itemValue = item.originValue[1];
        let data = util.number.getUnitNumber(itemValue, 2, 1)

        str += '<span class="tooltip-item"><span style="background:'+item.color+';" class="symbol-rect">dd</span>' +item.name+': '+ data+'</span>';
      })
      return str;
    },
    style: {
      backgroundColor: undefined,
      textAlign: 'center',
      width: '100%'
    }
  }
}

export var getJudge = function(){
  return {
    trigger: 'axis',
    $axisIndex: 0,
    position: [0, 222],
    alwaysShowContent: true,
    confine: false,
    formatter: function(d){
      var str = ''
      d.allSeries.map(function(item, i) {
        let itemValue = item.originValue[1];
        let data;
        if (item.color === grey) {
          data = itemValue.toFixed(2)
        }else{
          data = util.number.getUnitNumber(itemValue, 2, 1)
        }

        str += '<span class="tooltip-item"><span style="background:'+item.color+';" class="symbol-rect">dd</span>' +item.name+': '+ data+'</span>';
      })
      return str+'<span class="tooltip-item"><span style="background:'+blue+';opacity: 0.3;" class="symbol-rect">dd</span>低估</span><span class="tooltip-item"><span style="background:'+yellow+';opacity: 0.3;" class="symbol-rect">dd</span>适中</span><span class="tooltip-item"><span style="background:'+red+';opacity: 0.3;" class="symbol-rect">dd</span>高估</span>';
    },
    style: {
      backgroundColor: undefined,
      textAlign: 'center',
      width: '100%'
    }
  }
}

export var getJudge2 = function(){
  return {
    trigger: 'axis',
    $axisIndex: 0,
    position: [0, 222],
    alwaysShowContent: true,
    confine: false,
    formatter: function(d){
      var str = ''
      d.allSeries.map(function(item, i) {
        let itemValue = item.originValue[1];
        let data = util.number.getUnitNumber(itemValue, 2, 1)

        str += '<span class="tooltip-item"><span style="background:'+item.color+';" class="symbol-rect">dd</span>' +item.name+': '+ data+'</span>';
      })
      return str+'<span class="tooltip-item"><span style="background:'+blue+';opacity: 0.3;" class="symbol-rect">dd</span>宽松</span><span class="tooltip-item"><span style="background:'+yellow+';opacity: 0.3;" class="symbol-rect">dd</span>适中</span><span class="tooltip-item"><span style="background:'+red+';opacity: 0.3;" class="symbol-rect">dd</span>从紧</span>';
    },
    style: {
      backgroundColor: undefined,
      textAlign: 'center',
      width: '100%'
    }
  }
}
